import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { handleLoading } from "../../store/actions/loadingAction";
import {
  editCurrentUser,
  updateUser,
} from "../../store/actions/usersAction";
import validator from "validator";
import i18next, { t } from "i18next";
import dayjs from "dayjs";
import ArrayIndex from "../../components/UI/AddingData/ArrayIndex";
import { fetchCredential } from "../../store/actions/credentialsAction";
import { ActivityIndicator } from "react-native-web";
import { store } from "../../App";
import InstanceIndex from "../../components/UI/AddingData/InstanceIndex";
import RequestModal from "../../components/utils/RequestModal";
import { fetchLastMembership } from "../../store/actions/membershipsAction";
import CommonInputsContainer from "../../components/UI/TableView/CommonInputsContainer";
import axios from "axios";
const smalltalk = require("smalltalk");

const phoneUtil =
  require("google-libphonenumber").PhoneNumberUtil.getInstance();

function CreateUser() {
  const history = useHistory();
  const currentUser = useSelector((state) => state.users.currentUser);
  const [requestModal, setRequestModal] = useState(false);
  const [base64Image, setBase64Image] = useState(null);
  const location = useLocation();
  const accessGroups = useSelector((state) => state.accessGroups.accessGroups)
  const [lastMembership, setLastMembership] = useState()

  const onChangeValue = (type, value) => {
    switch (type) {
      case 0:
        currentUser.name = value;
        break;
      case 1:
        currentUser.location = value;
        break;
      case 2:
        currentUser.phone = value;
        break;
      case 5:
        currentUser.gender = Number(value);
        break;
      case 6: {
        currentUser.start_datetime = dayjs(value || undefined)
          .utc(value || undefined)
          .hour("00")
          .minute("00")
          .format();

        break;
      }
      case 7: {
        currentUser.birthDate = dayjs(value || undefined)
          .utc(value || undefined)
          .hour("00")
          .minute("00")
          .format();

        break;
      }
      default:
        break;
    }

    editCurrentUser({ ...currentUser });
  };

  //! if user not expired
  const isUpdatePath = location.pathname.includes("update");

  const onSubmit = async (isUpdateCurrentPackage) => {
    try {
      // handleLoading();
      await checkValidation();
      if (
        dayjs().diff(currentUser.expiry_datetime, "hour") >= 0 ||
        !currentUser._id ||
        isUpdateCurrentPackage
      ) {
        history.push(
          `${window.location.pathname}/selectPackage?${isUpdateCurrentPackage ? "isUpdateCurrentPackage=1" : ""
          }`
        );
      } else {
        await updateUser(currentUser, true, base64Image);
        history.goBack();
      }

      // handleLoading();
    } catch (e) {
      handleLoading();
      smalltalk.alert("Error", JSON.stringify(e));
    }
  };

  const checkValidation = async () => {
    if (currentUser.email && !validator.isEmail(currentUser.email)) {
      throw "Invlaid Email";
    }
    if (!currentUser.name) {
      throw "Invlaid Name";
    }
    if (!currentUser.phone) {
      throw "Invlaid phone number";
    }
    if (currentUser.gender === undefined) {
      throw "تکایە ڕەگەز هەڵبژێرە";
    }
    if (currentUser.tempEndDate && !currentUser.tempNumberOrder) {
      throw "تکایە ژمارەی وەسڵەکەی بنووسە";
    }
  };

  const onUpdateFaceId = async (group) => {
    smalltalk.confirm("", t("areYouSureYouWantUpdateFaceID?")).then(() => {
      history.push(`${window.location.pathname}/getUserCredentials?faceIp=${group.ip}`);
    });
  };

  const advancePurchase = () => {
    history.push(
      `${window.location.pathname}/selectPackage?advancedPurchase=1`
    );
  };

  const getCredential = async () => {
    const credential = await fetchCredential(currentUser._id);
    if (credential && credential[0]) {
      setBase64Image(credential[0].credential);
    } else {
      // const base = await getBase64Image(currentUser);
      // if (base) setBase64Image(base);
      setBase64Image(false);
    }
  };

  const onSelectBalance = () => {
    history.push(`/users/update/selectBalance`);
  };

  const onPrint = () => {
    history.push(`/users/update/printPackage`);
  };

  const resetAccount = async () => {
    smalltalk
      .confirm("", t("areYouSureYouWantToResetYourMobileAccount?"))
      .then(async () => {
        try{
          handleLoading();
          await axios.post(`/users/resetAccount/${currentUser._id}`)
          handleLoading();
        } catch (e) {
          handleLoading();
          smalltalk.alert("Error", JSON.stringify(e));
        }
        history.goBack();
      });
  };

  useEffect(() => {
    if (currentUser && currentUser._id) getCredential();
    else store.dispatch({ type: "CREATE_CREDENTIAL" });
  }, [currentUser]);

  const sendRequest = () => {
    setRequestModal(!requestModal);
  };
  const onRequestCourse = () => {
    history.push(`/users/update/requestCourse`);
  };
  const onClickPhysicalTherapy = () => {
    history.push(`/users/physical-therapy`);
  };

  useEffect(() => {
    setup()
  }, []);

  const setup = async () => {
    try {
      if (currentUser._id) {
        const last = await fetchLastMembership(currentUser._id)
        setLastMembership(last)
      }
    } catch (e) {
      alert('ببورە هەڵەیەک ڕویدا')
    }
  }

  const menu = [
    //   {
    //   title: 'sendRequest',
    //   onClick: () => sendRequest(),
    //   showType: 2,//0 when user expire, 1 user active id,2 active or expire, 3 not created user yet
    // },
    {
      title: 'printLastMembership',
      onClick: () => onPrint(),
      showType: 1,
    }, {
      title: 'addBalance',
      onClick: () => onSelectBalance(),
      showType: 1,
    }, {
      title: 'requestedCourse',
      onClick: () => onRequestCourse(),
      showType: 1,
    },
    // {
    //   title: 'addPhysicalTherapy',
    //   onClick: () => onClickPhysicalTherapy(),
    //   showType: 1,
    // },
    {
      title: 'advancePurchase',
      onClick: () => advancePurchase(),
      showType: 1,
    }, {
      title: 'resetMobileAccount',
      onClick: () => resetAccount(),
      showType: 2,
    },
  ]
  if (currentUser._id && accessGroups) {
    accessGroups.map((ag) => (
      menu.push({
        title: 'updateFaceIdOf' + " " + ag.name,
        onClick: () => onUpdateFaceId(ag),
        showType: 1,
      })
    ))
  }
  if (lastMembership && lastMembership.date === dayjs().format('YYYY-MM-DD')) {
    menu.push({
      title: 'updateCurrentPackage',
      onClick: () => onSubmit(true),
      showType: 1,
    })
  }
  if (!currentUser) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center flex-1 bg-[#f9f9f9] w-full">
      {requestModal && (
        <RequestModal
          data={currentUser}
          requestType={0}
          toggleModal={sendRequest}
        />
      )}
      <CommonInputsContainer
        menu={!isUpdatePath ? currentUser._id ? menu.filter(a => a.showType === 0 || a.showType === 2) : null : menu.filter(a => a.showType === 1 || a.showType === 2)}
        onSave={onSubmit}
        onSaveTitle={!isUpdatePath ? t("save") : t("update")}
        title={currentUser?.name || t('user')} >
        <InstanceIndex label={t("id")} value={`#${currentUser && currentUser.bioStarID ? currentUser.bioStarID : ''}`} />
        <TextInput
          placeHolder={t('name')}
          onChangeValue={(type, text) => onChangeValue(0, text)}
          label={t('name')}
          value={currentUser?.name}
        />
        <TextInput
          placeHolder={t('phoneNumber')}
          onChangeValue={(type, text) => onChangeValue(2, text)}
          label={t('phoneNumber')}
          value={currentUser?.phone}
        />
        {/* <TextInput
          placeHolder={t('location')}
          onChangeValue={(type, text) => onChangeValue(1, text)}
          label={t('location')}
          value={currentUser?.location}
        /> */}
        {/* <DateInput value={currentUser?.birthDate ? dayjs(currentUser?.birthDate).format('YYYY-MM-DD') : null} type={6} onChangeValue={(type, value) => onChangeValue(7, value,)} label={t('birthDate')} /> */}
        <ArrayIndex
          label={t("gender")}
          value={currentUser.gender}
          data={[
            { type: 0, label: "male" },
            { type: 1, label: "female" },
          ]}
          valType={1}
          index={"type"}
          onChangeValue={onChangeValue}
          type={5}
        />
        {currentUser?._id && <>
          {lastMembership && <InstanceIndex label={t("lastMembershipDate")} value={`${lastMembership.date}`} />}
          <InstanceIndex color={isUpdatePath ? 'green' : 'red'} label={t("expiryDate")} value={`${dayjs(currentUser.expiry_datetime).format('YYYY-MM-DD HH:MM')} - ${dayjs(currentUser.expiry_datetime).fromNow()}`} />
        </>}
        {currentUser._id && (
          <ImageContainer label={t("image")} value={base64Image} />
        )}
      </CommonInputsContainer>
    </div >
  );
}

const TextInput = ({ label, value, placeHolder, onChangeValue, type }) => {
  const onChangeValueHandler = (e) => {
    let tx = e.target.value;
    onChangeValue(type, tx);
  };

  return (
    <div className="flex flex-row justify-between w-full p-6">
      <h1>{label}</h1>
      <input
        onChange={onChangeValueHandler}
        className="w-3/5 px-2 border-none outline-none h-9 bg-whiteCardColor"
        type={"text"}
        placeholder={placeHolder}
        value={value}
      />
    </div>
  );
};

const DateInput = ({ label, value, placeHolder, onChangeValue, type }) => {
  const onChangeValueHandler = (e) => {
    let tx = e.target.value;
    onChangeValue(type, tx);
  };

  return (
    <div className="flex flex-row justify-between w-full p-6">
      <h1>{label}</h1>
      <input
        onChange={onChangeValueHandler}
        className="w-3/5 px-2 border-none outline-none h-9 bg-whiteCardColor"
        type={"date"}
        placeholder={placeHolder}
        value={value}
        min={type === 6 ? undefined : new Date().toISOString().split("T")[0]}
      />
    </div>
  );
};

export const CustomBtn = ({
  onClick,
  label,
  bgColor,
  labelColor = "text-white",
  width = null,
}) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}

      className={
        "w-4/5 p-4 border cursor-pointer select-none hover:opacity-80" +
        " " +
        bgColor
      }
      style={{ width }}
    >
      <h1 className={labelColor}>{t(label)}</h1>
    </div>
  );
};

const ImageContainer = ({ label, value }) => {
  return (
    <div className="flex flex-row justify-between w-full p-6">
      <h1>{label}</h1>
      {value !== null ? (
        value === false ? (
          <h1>وێنە نیە</h1>
        ) : (
          <img
            src={`${value}`}
            width={100}
            height={100}
          />
        )
      ) : (
        <ActivityIndicator size={"large"} />
      )}
    </div>
  );
};
const LastMembershipContainer = ({ label, value }) => {
  const language = i18next.language

  return (
    <div className="flex flex-row justify-between w-full p-6">
      <h1>{label}</h1>
      {value !== null ? (
        value === false ? (
          <h1>کۆتابەژداریکردن نەدۆزرایەوە</h1>
        ) : (
          <h1>{value?.package?.labelDetails[`in` + language.charAt(0).toUpperCase() + language.slice(1)]?.title}</h1>
        )
      ) : (
        <ActivityIndicator size={"large"} />
      )}
    </div>
  );
};

export default CreateUser;
